const CACHE_PREFIX = "ooredoo_bundle_cache_v1";
const CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

const appendQueryParam = (url, param) => {
  if (!url || typeof url !== "string") {
    return url;
  }
  return url.includes("?") ? `${url}&${param}` : `${url}?${param}`;
};

export const getOoredooCachedImageUrl = (url, refreshToken = 0) => {
  if (typeof window === "undefined" || !url || url.startsWith("data:")) {
    return url;
  }

  const storageKey = `${CACHE_PREFIX}:${url}`;

  try {
    if (refreshToken) {
      window.localStorage.removeItem(storageKey);
    }

    const now = Date.now();
    const storedValue = window.localStorage.getItem(storageKey);

    if (storedValue) {
      try {
        const parsed = JSON.parse(storedValue);
        if (
          parsed &&
          parsed.token &&
          parsed.timestamp &&
          now - parsed.timestamp <= CACHE_TTL_MS
        ) {
          return appendQueryParam(url, `cache=${parsed.token}`);
        }
      } catch (error) {
        window.localStorage.removeItem(storageKey);
      }
    }

    const token = Math.random().toString(36).slice(2, 10);
    const record = JSON.stringify({ token, timestamp: now });
    window.localStorage.setItem(storageKey, record);

    return appendQueryParam(url, `cache=${token}`);
  } catch (error) {
    return url;
  }
};

export default getOoredooCachedImageUrl;

